

class VariantRadios extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);    
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    if (!this.currentVariant){
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateURL();
      this.renderProductInfo();
    }
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    var fetured_id = this.currentVariant.featured_media.id;
    if(document.querySelector('.media-thumb')){
      document.querySelectorAll('.media-thumb .media-grid-column').forEach(function(e){
        var mediaid = e.dataset.id;
        if(mediaid==fetured_id){
       swiper2.slideTo(e.dataset.index,1000,false);
    
        }
      });
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.option-wrap'));
    const fieldlen = fieldsets.length;
    let option_count = 0;
    fieldsets.forEach(function(eachfield){
      var checked_gender = eachfield.querySelector('input:checked');
      if(checked_gender){
        option_count++;
      }
    });
    this.options = fieldsets.map((fieldset) => {
      if(option_count>=fieldlen){
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      }
    });
    if(option_count>=fieldlen){
      document.querySelector('.choose-cart').classList.remove('hide-selectore-button');
      document.querySelector('.choose-selector').classList.add('hide-selectore-button');
      document.querySelector('.product-btn').classList.add('now-add-to-cart');
    }else{
      document.querySelector('.choose-cart').classList.add('hide-selectore-button');
      document.querySelector('.choose-selector').classList.remove('hide-selectore-button');
      document.querySelector('.product-btn').classList.remove('now-add-to-cart');
    }   
  }



  
  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    .then((response) => response.text())
    .then((responseText) => {
      const id = `price-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);
      const qtyText = document.getElementById('less-qty-text');
      var variantQty = 0;
      html.querySelectorAll('variant-radios').forEach(function (variantRadio) {
        variantQty = variantRadio.dataset.availableQty;
      });
      if (variantQty == 1){
        qtyText.style.display = "block";
      }else{
        qtyText.style.display = "none";
      }
      if (source && destination) destination.innerHTML = source.innerHTML;
      if(this.currentVariant){
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    var addCartBtn = document.querySelector(".product-addcart.add");
    var soldOutBtn = document.querySelector(".product-addcart2.sold-out-btn");
    if (this.currentVariant.available) {
        soldOutBtn.style.display = 'none'
        addCartBtn.style.display = 'flex'
    } else {
        soldOutBtn.style.display = 'flex'
        addCartBtn.style.display = 'none'
    }
    // var lessText = document.querySelector("#less-qty-text");
    // console.log(this.currentVariant)
    // if (this.currentVariant.available) {
    //     lessText.style.display = 'none'
    // } else {
    //     lessText.style.display = 'block'
    // }
    if (!addButton) return;
    // if (disable) {
    //   addButton.setAttribute('disabled', 'disabled');
    //   if (text) addButtonText.textContent = text;
    // } else {
    //   addButton.removeAttribute('disabled');
    //   addButtonText.textContent = window.variantStrings.addToCart;
    // }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-radios', VariantRadios);
function variant_drodown(){
  if(document.querySelector('.dropdown-wrap')){
    document.querySelectorAll('.dropdown-wrap').forEach(function(dropdown){
      dropdown.querySelector('.variant-dropdown').addEventListener('click',function(event){
        event.preventDefault();
        dropdown.classList.toggle('active');
        dropdown.querySelectorAll('input[type="radio"]').forEach(function(e){
          e.addEventListener('change',function(button){
            dropdown.classList.remove('active');
            dropdown.querySelector('.variant-dropdown').innerHTML = button.path[0].value;
          });
        });
      });
    });
  }
}

var addtoCart = document.querySelectorAll('.product-addcart');
addtoCart.forEach((addCrt) => {
  addCrt.addEventListener('click',function(evt){
    evt.preventDefault();
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var cartform = document.querySelector('.product-addcart').closest('form');
    const formData = new FormData(cartform);  
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        document.querySelector('.product-form-error').innerHTML = response.description;
        setTimeout(function(e){
          document.querySelector('.product-form-error').innerHTML  = '';
        },2000);
        return;
      }else{
        if(typeof load_cart == 'function'){
          load_cart();
          if ($(window).width() > 767) {
            setTimeout(function(e){
              document.querySelector('body').classList.add('open-drawer');
            },500); 
          }else{
             // var pro_title = response.product_title;
             //    document.querySelector(".product-title").innerHTML = "";        
             //    document.querySelector(".product-title").innerHTML = 
             //    `<p class="product-title">${pro_title}</p>`;
  
              setTimeout(() => {
                $('.main_cart_notification').addClass('active');
              }, "0")
              setTimeout(() => {
                $('.main_cart_notification.active').removeClass('active');
              }, "5000")
          }
        }else{
          window.location.href = "/cart";
        }
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
  
    });
  });
});
function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}
var swiper2;
function product_slider(){
  if(document.querySelector('.media-slider')){
    var swiper = new Swiper(".media-thumb", {
      loop: false,
      spaceBetween: 0,
    //  slidesPerView: 'auto'
    });
    swiper2 = new Swiper(".media-nav", {
      slidesPerView:1.04,
      loop: false,
      spaceBetween: 5,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      thumbs: {
        swiper: swiper,
      }
    });
  }
}
product_slider();
variant_drodown();
document.addEventListener("shopify:section:load", function(event) {
  product_slider();
  variant_drodown();
});

function getElementY(query) {
  return window.pageYOffset + document.querySelector(query).getBoundingClientRect().top
}
function doScrolling(element, duration) {
	var startingY = window.pageYOffset
  var elementY = getElementY(element)
  var targetY = document.body.scrollHeight - elementY < window.innerHeight ? document.body.scrollHeight - window.innerHeight : elementY
	var diff = targetY - startingY
  var easing = function (t) { return t<.5 ? 4*t*t*t : (t-1)*(2*t-2)*(2*t-2)+1 }
  var start
  if (!diff) return
	window.requestAnimationFrame(function step(timestamp) {
    if (!start) start = timestamp
    var time = timestamp - start
    var percent = Math.min(time / duration, 1)
    percent = easing(percent)
    window.scrollTo(0, startingY + diff * percent)
    if (time < duration) {
      window.requestAnimationFrame(step)
    }
  })
}
if(document.querySelector('.choose-selector')){
  if (window.innerWidth < 641) {
    document.querySelector('.choose-selector a').addEventListener('click', doScrolling.bind(null, '#product-form-installment', 2000))
  }
}



// var swiper = new Swiper('.swiper-container', {
//   direction: 'vertical',
//   slidesPerView: 1.2,
//   mousewheel: true,
//     pagination: {
//       el: '.swiper-pagination',
//     },
// });



let index = 1;

const on = (listener, query, fn) => {
	document.querySelectorAll(query).forEach(item => {
		item.addEventListener(listener, el => {
			fn(el);
		})
	})
}

on('click', '.selectBtn', item => {
	const next = item.target.nextElementSibling;
	next.classList.toggle('toggle');
	next.style.zIndex = index++;
});
on('click', '.option', item => {
	item.target.parentElement.classList.remove('toggle');

	const parent = item.target.closest('.select').children[0];
	parent.setAttribute('data-type', item.target.getAttribute('data-type'));
	parent.innerText = item.target.innerText;
})


// var wishlistElements = document.querySelectorAll('.pro-page-wishlist');
// wishlistElements.forEach(function(element) {
//   element.addEventListener('click', function() {
//     console.log('click----------------->')
//     var notificationElements = document.querySelectorAll('.wishlist-notifiaction');
//     notificationElements.forEach(function(notificationElement) {
//       notificationElement.classList.add('active');
//     });
//   });
// });


// jarallax(document.querySelectorAll('.jarallax'), {
//     speed: 0.2
// });



function onSwymLoadCallback(swat) {
  // Please make all SWYM-related API calls inside this function.
  // You can use the swat argument within this scope.
  if (swat) {
  console.log("Swym scripts tags are installed on your store");
      let event = 'sw:addedtowishlist';


// Define the event listener function
let listener = function(e) {
	var data = e.detail.d;
	console.log("YAY! Added the product to wishlist", data);
    $('.wishlist-notifiaction').addClass('active');
            setTimeout(function() {
                $('.wishlist-notifiaction').removeClass('active')
            },5000);
};


// Add listener for the 'addedtowishlist' event to the Swym Event Layer
swat.evtLayer.addEventListener(event, listener);
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(onSwymLoadCallback);

$(document).ready(function() {

    // product zoom desk

$('.media-grid-column').click(function() {
  var mediaid = $(this).find('img').attr('data-id');
  
  if (mediaid == undefined) {
      mediaid = $(this).find('video').attr('data-id');
  }
  var mediaindex = $('.zoom-slider .media-grid-inner[data-id="' + mediaid + '"]').index();
  $('.zoom-popup').fadeIn(300);
  const swiper = new Swiper('.zoom-slider.swiper', {
      slidesPerView: 1.5,
      spaceBetween: 8,
      initialSlide: mediaindex,
      breakpoints: {
          0: {
              slidesPerView: 1,
          },
          768: {
              slidesPerView: 1.2,
          },
          992: {
              slidesPerView: 1.5,
          }
      },
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: ".swiper-pagination",
      },
  });

  // Ensure video reloads and autoplays
  var videoElement = $('.zoom-slider .media-grid-inner[data-id="' + mediaid + '"]').find('video');
  if (videoElement.length) {
      videoElement[0].load();
      videoElement[0].play();
  }

  $('main').css('z-index', '99');
  $('body').addClass('overflow');
});

$('.product-zoom').click(function() {
  $('.media-grid-column.swiper-slide-active').trigger('click');
});

$('.zoom-popup-colse svg , .zoom-inner .media-grid-inner').click(function() {
  $('.zoom-popup').fadeOut(300);
  $('main').css('z-index', 'auto');
  $('body').removeClass('overflow');
});

// product zoom desk

  // product page accordian


$(document).on('click', '.accordian-top li', function () {
  var $this = $(this);
  var id = $this.attr('data-handle');
  var cust_class = "." + id;
  var $target = $(cust_class);

  // Toggle active state on header
  $this.addClass('active').siblings().removeClass('active');

  // Deactivate all and activate the selected one
  $('.accordian-bottom li.mob-tab').removeClass('active');
  $target.addClass('active');
});

  // product page accordian

  // product page dot slider

  if( $(".product-media").length > 0){
    $(window).scroll(function() {
      if($(window).width() >= 992){
        var mainScroll = $(window).scrollTop();
        $('.media-grid .media-grid-column').each(function(i) {
          if ($(this).position().top <= mainScroll) {
            // console.log($(this).position().top)
            $('.inner-dot .dot.active').removeClass('active');
            $('.inner-dot .dot').eq(i).addClass('active');
          }
        });
      }
    });
  }
  
  // product page dot slider

  // product page accordian mobile

  if($(window).width() < 992){
    $(document).on('click','.accordian-bottom li.mob-tab',function() {
      $(this).toggleClass('active').siblings().removeClass('active');
      $(this).find('.tab-desc').slideToggle();
      $(this).siblings().find('.tab-desc').slideUp();
    })
  }
  
  // product page accordian mobile


  // size chart

  $(document).on('click','.sizechart-pop-up',function(){
    $('.product-size-chart').addClass('active');
    $('body').addClass('overflow')
  })
  $(document).on('click','.size-popup-close',function(){
    $('.product-size-chart').removeClass('active');
    $('body').removeClass('overflow')
  })
  
  // size chart

  // esc click zoom slider closed

     document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" || event.key === "Esc") {
        var zoomPopup = document.querySelector(".zoom-popup");
        if (zoomPopup.style.display === "block") {
          $('.zoom-popup').fadeOut(300);
          $('body').removeClass('overflow')
        }
      }
    });
  // esc click zoom slider closed
  

  if( $(".product-more-variant-product").length > 0){
    if($(window).width() >= 992){
      $('.variant-row-list .singal-var input').on('input', function() {
        $('.product-media .media-grid').addClass('active')
        var inputValue = $(this).val();
        $('.product-media .media-grid-column img').each(function (e) {
            var expectedValue = $(this).attr('alt');
            var newAlt = expectedValue.split('_')[1].toUpperCase(); 
            if(newAlt.includes(inputValue)){
              $(this).closest('.media-grid-column').show()
            }else{
               $(this).closest('.media-grid-column').hide()
            }
        })
      });
    }
  }

  var $toptitle = $('.var-label-main .var-label');
  if ( $toptitle.text() == 'Size' )
  $toptitle.text('Maat');

  $(document).on('click','.bottom-add-to-cart .product-btn .var',function(){
    $('.section-product').addClass('z-index')
    $('.one-tab-bg').addClass('active')
    $('.one-tab-bg .one-tab').addClass('active')
    $('.bottom-add-to-cart').removeClass('active')
  })

  // Fixed add-to-cart on mobile
  if (window.innerWidth <= 991) {
    const addToCart = document.querySelector('.snippet-addto-cart');
    const anchor = document.querySelector('.addto-cart-anchor');
    const footer = document.querySelector('#shopify-section-footer');
    
    if (addToCart && anchor) {
      const addToCartHeight = addToCart.offsetHeight;
      let anchorVisible = false;
      let footerVisible = false;
      
      const updateDisplay = () => {
        if (footerVisible) {
          addToCart.style.display = 'none';
        } else if (anchorVisible) {
          addToCart.style.display = '';
          addToCart.classList.add('docked');
        } else {
          addToCart.style.display = '';
          addToCart.classList.remove('docked');
        }
      };
      
      const anchorObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          anchorVisible = entry.isIntersecting;
          updateDisplay();
        });
      }, {
        threshold: 0,
        rootMargin: `0px 0px -${addToCartHeight + 16}px 0px`
      });
      
      anchorObserver.observe(anchor);
      
      if (footer) {
        const footerObserver = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            footerVisible = entry.isIntersecting;
            updateDisplay();
          });
        }, {
          threshold: 0,
          rootMargin: '0px'
        });
        
        footerObserver.observe(footer);
      }
    }
  }
  
})














